import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, ButtonGroup, LinearProgress, Tooltip ,FormControl, InputAdornment, OutlinedInput, Drawer, Box} from "@mui/material";
import MUIDataTable ,{TableFilterList} from "mui-datatables";
import { useEffect, useState } from "react";
import Chip from '@mui/material/Chip';
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { baseUrl} from "../../variables/variables";
import { Download, SearchOutlined } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../components/Loader";
import { PdfService} from "../../adapter/PdfService";

export default function Templates() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [src,setsrc] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  
  const previewPDf = (html) =>  {
    PdfService({html:html})
    .then((response) => {
       if(response.status === 200) {
        setOpen(true)
        const byteCharacters = atob(response.data.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
           setsrc(url)
       }
  
    })
    .catch((e)=>{
      // ShowNotification(e?.response?.data?.errors[0], "danger")
    })
   }

  useEffect(() => {
    setLoading(true);
    const settings = {
      method: "GET",
      headers: {
        // Authorization: "Bearer " + Suser.token + "",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
     axios.get(`${baseUrl}/templates`,settings)
     .then((res)=>{
        if(res.data.status !== "SUCCESS"){
          setLoading(false)
          toast.error("Something went wrong !");
          setData([])
          return
        }
        setData(res.data.data)
        setLoading(false)
     })
     .catch((err)=>{
      setLoading(false)
      toast.error(err.message);
      setData([])
      return
     })


  }, []);


  const handleEdit = (id) => {
    navigate("/app/edit-template", {
      state:  {templateData : data[id.rowIndex]} 
      })
  };


  function downloadCSVFromBase64(base64String, fileName) {
    // Decode the base64 string
    const decodedData = atob(base64String);

    // Convert the decoded data to a byte array
    const byteNumbers = new Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
        byteNumbers[i] = decodedData.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
  const handleDownloadCsv = (id) =>{
       axios.post(`${baseUrl}/templates/${id}/format`)
       .then((res)=>{
         downloadCSVFromBase64(res.data.data.fileContent,res.data.data.fileName?.replaceAll(".",""))
       })

  }
  const handlePreview = (tableMeta)=>{
    previewPDf(data[tableMeta.rowIndex].template)
  }
  const columns = [
    { name: "templateName", label: "Template Name", width: 100,options:{    customHeadRender: (columnMeta) => {
      return (
        <th key={columnMeta.index} style={{padding:"16px",textAlign:"left",color:"rgba(0, 0, 0, 0.6)"}}>
          {columnMeta.label}
        </th>
      );
    },} 
  },
    {
      name: "documentType",
      label: "Document Type",
      width: 100,
      options:{
        customHeadRender: (columnMeta) => {
          return (
            <th key={columnMeta.index} style={{padding:"16px",textAlign:"left",color:"rgba(0, 0, 0, 0.6)"}}>
              {columnMeta.label}
            </th>
          );
        },
      }
    },
    {
      name: "id",
      label: "CSV Format",
      width: 100,
      textAlign: "center",
      options: { align: "center" ,
      customHeadRender: (columnMeta) => {
        return (
          <th key={columnMeta.index} style={{padding:"16px",textAlign:"center",color:"rgba(0, 0, 0, 0.6)"}}>
            {columnMeta.label}
          </th>
        );
      },
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: "center" }}>
            <ButtonGroup style={{ alignContent: "center" }}>
              <Tooltip title="Download CSV Format">
                <Button
                  style={{
                    color: "rgb(0, 81, 134)",
                    border: "none",
                    cursor: "pointer",
                    width:"20px"
                  }}
                >
                  <Download onClick={() => handleDownloadCsv(value)} sx={{width:"20px"}} />
                </Button>{" "}
              </Tooltip>
            </ButtonGroup>
          </div>
        );
      },
    
    },
    },
    {
      name: "id",
      label: "Action",
      width: 150,
      options: {
        filter: true,
        customHeadRender: (columnMeta) => {
          return (
            <th key={columnMeta.index} style={{color:"rgba(0, 0, 0, 0.6)"}}>
              {columnMeta.label}
            </th>
          );
        },
        customBodyRender: (value,updateValue,columnMeta) => {
          return (
            <div style={{ textAlign: "center" }}>
              <ButtonGroup style={{ alignContent: "center" }}>
                <Tooltip title="Edit">
                  <Button
                    style={{
                      color: "rgb(0, 81, 134)",
                      border: "none",
                      cursor: "pointer",
                      width:"20px"
                    }}
                  >
                    <EditIcon onClick={() => handleEdit(updateValue)} sx={{width:"20px"}} />
                  </Button>{" "}
                </Tooltip>
                <Tooltip title="View">
                  {" "}
                  <Button
                    style={{
                      color: "rgb(0, 81, 134)",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => handlePreview(updateValue)}
                  >
                    <VisibilityIcon  sx={{width:"20px"}} />
                  </Button>
                </Tooltip>
              </ButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    customBodyRender: (value, tableMeta, updateValue) => {
      return (
        <span
          style={{
            display: "block",
            textAlign: "center",
          }}
        >
          {value}
        </span>
      );
    },
  };
  const CustomChip = ({ label, onDelete }) => {
    return (
        <Chip
            variant="outlined"
            color="secondary"
            label={label}
            onDelete={onDelete}
        />
    );
};
  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
};


  return (
    <>
      <div className="navView">
        <ToastContainer />
        <Loader loading={loading} />
        <div
          className="component-titleContainer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="component-title">Templates</h2>
          
       
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <FormControl style={{ width: "600px" }}>
          <OutlinedInput
            style={{
              borderRadius: "30px",
              border: "unset",
              background: "#f8f9fb",
            }}
            size="small"
            id="header-search"
            startAdornment={
              <InputAdornment position="start">
                <SearchOutlined />
              </InputAdornment>
            }
            aria-describedby="header-search-text"
            placeholder="Search Template"
            inputProps={{
              "aria-label": "weight",
            }}
          />
        </FormControl>
             <Link style={{ textDecoration: "none" }} to="/app/add-template">
            <Button
              color="secondary"
              // fullWidth
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Add New Template
            </Button>
          </Link>
        </div>
       
        {loading ? (
          <LinearProgress />
        ) : ( 
          <MUIDataTable data={data} columns={columns} options={options} components={{
            TableFilterList: CustomFilterList,
          }} />
        )}
      </div>
      <Drawer open={open} sx={{zIndex:"1203"}} anchor='right' onClose={toggleDrawer(false)}>
      <Box sx={{width:"50vw",color:"#000"}}>
      <iframe style={{width:"100%",height:"100vh"}} src={src}  />
      </Box>
      </Drawer>
    </>
  );
}
